import React, { useState } from 'react';
import { Icon, Table } from 'semantic-ui-react';
import CSS from 'csstype';
import { formatBytes } from '../../utils/siteFunctions';
import Button from '../elements/Button';
import Dropzone from '../elements/Dropzone';

const Uploader = ({ value, onChange, style }: UploaderProps) => {
	/// Events
	const handleDrop = (acceptedFiles: File[]) => {
		if (onChange !== undefined && onChange !== null)
			onChange?.(value?.concat(acceptedFiles) || []);
	};

	const handleRemoveFile = index => {
		if (onChange !== undefined && onChange !== null)
			onChange?.(value?.slice(0, index).concat(value.slice(index + 1)) || []);
	};

	/// Render
	return (
		<div style={style}>
			<Dropzone onDrop={handleDrop}>
				<div className="dropzone-header">
					<Icon name="file outline" />
					Drag and Drop or Browse Files
				</div>
				<div className="dropzone-content">
					<div>Maximum file size is 200MB</div>
					<div>Maximum number of files is 10</div>
					<div>Accepted: .doc, .docx, .pdf, .xlsx</div>
				</div>
			</Dropzone>
			{ (value?.length || 0) > 0 && (
				<Table striped compact="very"><Table.Body>
					{value?.map((x, index) => (
						<Table.Row key={index}>
							<Table.Cell collapsing>{x.name}</Table.Cell>
							<Table.Cell style={{ textAlign: 'right' }}>{formatBytes(x.size)}</Table.Cell>
							<Table.Cell collapsing>
								<Button
									basic
									borderless
									compact
									icon
									onClick={ e => handleRemoveFile(index) }
									title="Remove this file from the list of files to upload."
								>
									<Icon
										name="remove"
										fitted
										color="red"
									/>
								</Button>
							</Table.Cell>
						</Table.Row>
					))}
				</Table.Body></Table>
			)}
		</div>
	);
};

export interface UploaderProps {
	value?: File[],
	onChange?: (files: File[]) => any,
	style?: CSS.Properties
}

export default Uploader;